import { Pipe, PipeTransform } from '@angular/core';

/**
 * Takes array of strings and returns single string with each list item on a new line
 */
@Pipe({
    name: 'joinList',
    standalone: false
})
export class JoinList implements PipeTransform {
    transform(lines: string[]): string {
        let list: string = '';
        lines.forEach((line, index) => {
            list += line + (index !== lines.length - 1 ? '\n' : '');
        });

        return list;
    }
}
